import React from 'react';

import { mergeFields } from '../forms/formFunctions';
import { FormLabel } from '../forms/FormLabel';
import { substitute } from '../../services/stringsubstitutions';

export const ContainerStack = ({ formGenerator, field, additional, collectionStack }) => {
    //   const { defaultClass } = additional;

    var content = (<></>);
    if(field.items != null && field.items.length > 0) {
            content = field.items.map((fld, sectionIndex) => {
            var newField = mergeFields(field, fld);

            const row = formGenerator.createControls(additional.addToValidationFunc, newField, '', collectionStack);
            if (row == null) return null;

            return row;
        });
    }
    else if(field.content != null) {
      content  = substitute(field.content, formGenerator.props.controller, [...collectionStack, formGenerator.getFormData()]);
    }

    var fieldLabel = { header: field.header, class: field.headerClass, style: field.headerStyle };


    return (
        <>
            {!!field.header && <FormLabel field={fieldLabel} additional={additional} formGenerator={formGenerator} />}
            {content}
        </>
    );
};
